<div class="login-container">
    <form [formGroup]="form" novalidate (appHttpClick)="login($event)" fxLayout="column" fxLayoutGap="8px" class="card"
        dynamicFlex="100|100|50|33|33">
        <mat-form-field fxFlex="100">
            <mat-icon class="padding-lr-1" matPrefix fontSet="fa" fontIcon="fa-user"></mat-icon>
            <input type="text" formControlName="username" matInput placeholder="{{ 'username' | translate }}" required>
            <mat-error>{{getErrorMessage(form.get('username'))}}</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="100">
            <mat-icon class="padding-lr-1" matPrefix fontSet="fa" fontIcon="fa-lock"></mat-icon>
            <input [type]="hidePassword ? 'password' : 'text'" formControlName="password" matInput
                placeholder="{{ 'password' | translate }}" required>
            <mat-icon class="padding-lr-1" (click)="hidePassword = !hidePassword" matSuffix fontSet="fa"
                [fontIcon]="hidePassword ? 'fa-eye-slash' : 'fa-eye'"></mat-icon>
            <mat-error>{{getErrorMessage(form.get('password'))}}</mat-error>
        </mat-form-field>
        <button fxFlex="100" type="submit" mat-raised-button color="primary">{{'login' |translate}}</button>
        <mat-divider></mat-divider>
    </form>
</div>